export default __webpack_public_path__ + "static/media/q6.d43c3481.svg";